import React from 'react';
import TableCell, { TableCellProps } from '@mui/material/TableCell';

interface TableCellFixedProps extends TableCellProps {
  children: React.ReactNode;
}

export const TableCellFixed = ({ children, ...props  }: TableCellFixedProps) => {
    return (
        <TableCell style={{ maxWidth: '100px' }} {...props}>{children}</TableCell>
    );
}